
  import {
    QBadge,
    QBtn,
    QFooter,
    QHeader,
    QLayout,
    QPage,
    QPageContainer,
    QRouteTab,
    QSpace,
    QTabs,
    QToolbar,
    QDialog
  } from 'quasar'
  import Tasks from '../components/Tasks.vue'
  import { Component, Vue, Watch } from 'vue-property-decorator'
  import {Avatar, LanguagePicker, Lock as LockScreen, NewAccountInformation, ToolbarMenu} from '@parantion/components'

  @Component({
    components: {
      QTabs,
      QRouteTab,
      LockScreen,
      QFooter,
      QLayout,
      QPageContainer,
      QToolbar,
      QBtn,
      QHeader,
      QPage,
      QSpace,
      LanguagePicker,
      ToolbarMenu,
      Avatar,
      Tasks,
      QBadge,
      QDialog
    }
  })

  export default class Layout extends Vue {
    name: 'LayoutDefault'

    organisation = this.$store.state.parantion.user.id.oid
    isExpanded = false

    get profileImage () {
      return {backgroundImage: 'url(' + this.getProfilePhoto + ')'}
    }
    get getProfilePhoto () {
      const profilePic = this.$store.getters['parantion/user/getProfilePhoto']
      if (profilePic) {
        return profilePic
      } else {
        return 'data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjAiIGhlaWdodD0iMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiA8Zz4KICA8dGl0bGU+YmFja2dyb3VuZDwvdGl0bGU+CiAgPHJlY3QgeD0iLTEiIHk9Ii0xIiB3aWR0aD0iMjIiIGhlaWdodD0iMjIiIGlkPSJjYW52YXNfYmFja2dyb3VuZCIgZmlsbD0ibm9uZSIvPgogPC9nPgoKIDxnPgogIDx0aXRsZT5MYXllciAxPC90aXRsZT4KICA8ZWxsaXBzZSBzdHJva2U9Im51bGwiIGZpbGw9IiNmZmZmZmYiIHN0cm9rZS13aWR0aD0ibnVsbCIgc3Ryb2tlLW9wYWNpdHk9Im51bGwiIGN4PSIxMCIgY3k9IjEwIiBpZD0ic3ZnXzQiIHJ4PSI5LjkwNjI1MSIgcnk9IjkuODQzNzUxIi8+CiAgPHBhdGggc3Ryb2tlPSJudWxsIiBvcGFjaXR5PSIwLjY1IiBkPSJtMTAsMC4wMzEyNDljLTUuNTIsMCAtMTAsNC40NjYgLTEwLDkuOTY4NzVzNC40OCw5Ljk2ODc1IDEwLDkuOTY4NzVzMTAsLTQuNDY2IDEwLC05Ljk2ODc1cy00LjQ4LC05Ljk2ODc1IC0xMCwtOS45Njg3NXptMCwyLjk5MDYyNWMxLjY2LDAgMywxLjMzNTgxMyAzLDIuOTkwNjI1cy0xLjM0LDIuOTkwNjI1IC0zLDIuOTkwNjI1cy0zLC0xLjMzNTgxMyAtMywtMi45OTA2MjVzMS4zNCwtMi45OTA2MjUgMywtMi45OTA2MjV6bTAsMTQuMTU1NjI2Yy0yLjUsMCAtNC43MSwtMS4yNzYgLTYsLTMuMjA5OTM4YzAuMDMsLTEuOTgzNzgxIDQsLTMuMDcwMzc1IDYsLTMuMDcwMzc1YzEuOTksMCA1Ljk3LDEuMDg2NTk0IDYsMy4wNzAzNzVjLTEuMjksMS45MzM5MzggLTMuNSwzLjIwOTkzOCAtNiwzLjIwOTkzOHoiIGlkPSJzdmdfMSIvPgogPC9nPgo8L3N2Zz4='
      }
    }

    get firstName() {
      const firstName = this.$store.state.parantion.user.user.firstname
      return firstName ? firstName : ''
    }

    get insertion() {
      const insertion = this.$store.state.parantion.user.user.middlename
      return insertion ? insertion : ''
    }

    get fullName() {
      const lastName = this.$store.state.parantion.user.user.lastname
      return this.firstName + ' ' + this.insertion + ' ' + lastName
    }

    get orgLogo() {
      return this.$store.state.directus.orgLogo
    }

    get orgLogoMobile() {
      return this.$store.state.directus.orgLogoMobile
    }

    get background() {
      return this.$store.state.directus.backgroundImg
    }

    get fixedStyle() {
      if (this.$q.platform.is.desktop) return { position: 'fixed' }
    }

    get newTasks() {
      return this.$store.getters['tasks/getNewTasks']
    }

    get openTasks() {
      return this.$store.getters['tasks/getBusyTasks']
    }

    @Watch('newTasks')
    onNewTasks(val) {
      if (val.length > 0 && this.$router.currentRoute.name !== 'tasks') this.showNotification()
    }

    @Watch('openTasks')
    onOpenTasks(val) {
      if (val.length > 0 && this.$q.platform.is.mobile && this.$router.currentRoute.name !== 'tasks') this.showNotificationOpen()
    }

    async created() {
      if (this.$q.platform.is.mobile) await this.$store.dispatch('tasks/retrieveTasks')
      await this.getExtraFields()
      document.body.style.setProperty('--main-organisation-bg',
        `url('${this.background}') center center`)
    }

    showNotification() {
      let action = {}
      if (this.$q.platform.is.mobile) {
        action = {
          handler: () => {
            this.$router.push('/tasks')
          },
          label: this.$t('tasks.go.label'),
          textColor: 'black'
        }
      } else {
        action = {
          textColor: 'black',
          icon: 'close'
        }
      }

      this.$toasty.success(this.$t('tasks.new_task_available.message'), 'light-green-5', 'mdi-star-four-points-outline', action)
    }

    showNotificationOpen() {
      const action = {
        handler: () => {
          this.$router.push('/tasks')
        },
        label: this.$t('tasks.go.label'),
        textColor: 'black'
      }

      this.$toasty.success(this.$t('tasks.continue.message'), 'light-blue-5', 'mdi-star-four-points-outline', action)
    }

    logout() {
      this.$store.dispatch('parantion/user/logout')
      this.$router.push('/login')
    }

    setView() {
      this.isExpanded = !this.isExpanded
    }

    async getExtraFields() {
      try {
        await this.$store.dispatch('directus/getRegistrationFields')
      } catch (e) {
        /* tslint:disable */
        console.log('%ce', 'color: #11b0d8', e)
        /* tslint:enable */
      }
    }

    async openAccountInfo() {
      const fields = this.$store.getters['directus/getExtraFields']

      this.$q.dialog({
        component: NewAccountInformation,
        fields,
        unsubscribe: true,
        parent: this
      }).onOk(() => {
        this.getExtraFields()
      })
    }
  }
